<template>
  <div class="f-v f-ast">
    <donut-modal-sections-title title="Are you sure?" />
    <div class="t">Permanently delete {{ state.modal.data.folder.name }}?</div>
    <div class="t-sm gray m-tx1">Note: This action will only delete the folder, none of the Journeys inside.</div>
    <donut-modal-sections-actions
      button-text="Confirm"
      :is-warning="true"
      save-action="onboardingTagsOverview/deleteFolder"
      :save-args="{ folder: state.modal.data.folder }"
      :save-tracking="{ eventName: 'Journey Folders - Delete Modal Submitted' }"
      :loading-on-save="true"
    />
  </div>
</template>

<script setup>
  import { useStore } from 'vuex';

  const { state } = useStore();
</script>
